






























































































































































































































import {
  computed,
  defineComponent,
  PropType,
  toRefs,
  useRoute,
  useRouter
} from '~/utils/nuxt3-migration'
import {
  ClassifiedOfferEntry,
  OfferActions,
  OfferState
} from '~/models/classified/offers'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import { formatNumber } from '~/utils/number'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import { useI18n } from '~/compositions/i18n'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { ciChatBubble } from '~/icons/source/regular/chat-bubble'
import CImageGallery from '~/components/shared/configurable/image/CImageGallery.vue'
import { ciEnvelope } from '~/icons/source/regular/envelope'
import { ciOffers } from '~/icons/source/regular/offers'
import ClassifiedOfferActionButtons from '~/components/car/offers/ClassifiedOfferActionButtons.vue'
import ClassifiedOfferActionButton from '~/components/car/offers/ClassifiedOfferActionButton.vue'
import ClassifiedOfferPrice from '~/components/car/offers/ClassifiedOfferPrice.vue'

export default defineComponent({
  components: {
    ClassifiedOfferPrice,
    ClassifiedOfferActionButton,
    ClassifiedOfferActionButtons,
    CImageGallery,
    CConfirmationModal,
    CBadge,
    CPrice,
    CAvatar
  },
  props: {
    offer: {
      type: Object as PropType<ClassifiedOfferEntry>
    },
    fullRow: {
      type: Boolean,
      required: false,
      default: false
    },
    inBlock: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props, { emit }) {
    const { offer, fullRow, inBlock } = toRefs(props)
    const { t } = useI18n()

    const router = useRouter()
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const latestBid = computed(() => {
      return offer.value.latestBid
    })

    const isAdmin = computed(() => userGetters('isAdmin'))
    const isDealer = computed(() => userGetters('isOfTypeDealer'))

    const startingPrice = computed(() => {
      return (
        offer.value.classified.priceParked ||
        offer.value.classified.rawPrice ||
        0
      )
    })

    const showMessageButton = computed(() => {
      return (
        offerAccepted.value ||
        (received.value && (offerCancelled.value || fullRow.value))
      )
    })

    const canSeeThread = computed(() => {
      const threadAvailable = initialOfferMine.value
        ? offer.value.thread.showSender
        : offer.value.thread.showRecipient

      return (
        (!offerCancelled.value || fullRow.value) &&
        offer.value.thread.preview &&
        threadAvailable
      )
    })

    const thumbUrls = computed(() => {
      return (
        offer.value.classified.thumbsPatterns?.urls || [
          offer.value.classified.thumbPattern
        ]
      )
    })

    const noPhoto = computed(() => {
      return !offer.value.classified.thumbsPatterns?.urls
    })

    const formattedStartingPrice = computed(() => {
      return formatNumber(startingPrice.value) + ' €'
    })
    const route = useRoute()

    const received = computed(() => {
      return !userGetters('userIds').includes(latestBid.value.user.id)
    })

    const offerPending = computed(() => {
      return latestBid.value.state === OfferState.PENDING
    })
    const offerRejected = computed(() => {
      return latestBid.value.state === OfferState.REJECTED
    })
    const offerExpired = computed(() => {
      return latestBid.value.state === OfferState.EXPIRED
    })
    const offerAccepted = computed(() => {
      return latestBid.value.state === OfferState.ACCEPTED
    })
    const offerCancelled = computed(() => {
      return latestBid.value.state === OfferState.WITHDRAWN
    })
    const offerRejectedOrCancelled = computed(() => {
      return offerRejected.value || offerCancelled.value
    })

    const isCounteroffer = computed(() => {
      return offerPending.value && offer.value.bidCount > 1
    })

    const initialOfferMine = computed(() => {
      return userGetters('userIds').includes(offer.value.user.id)
    })

    const offersEnabled = computed(() => {
      return offer.value.classified.offersEnabled
    })

    const offerUser = computed(() => {
      const seller = offer.value.classified?.seller
      if (received.value) {
        return {
          displayName:
            latestBid.value.user.displayName ||
            latestBid.value.user.display_name,
          id: latestBid.value.user.id,
          avatar: latestBid.value.user.avatar
        }
      } else if (
        (isCounteroffer.value || offerAccepted.value) &&
        !initialOfferMine.value
      ) {
        return {
          displayName:
            offer.value.user.displayName || offer.value.user.display_name,
          id: offer.value.user.id,
          avatar: offer.value.user.avatar
        }
      }

      return {
        displayName: seller.name,
        id: seller.id,
        avatar: seller.avatar
      }
    })

    const stateInfo = computed(() => {
      if (!offersEnabled.value) {
        return {
          label: t('disabled::prosfora'),
          bg: fullRow.value ? 'tw-bg-grey-200' : 'tw-bg-grey-300',
          color: fullRow.value ? 'tw-text-grey-500' : 'tw-text-grey-600'
        }
      }
      if (isCounteroffer.value && received.value) {
        return {
          label: t('counteroffer'),
          bg: 'tw-bg-amber-900',
          color: 'tw-text-white'
        }
      }
      switch (latestBid.value.state) {
        case OfferState.PENDING:
          return {
            label: t('active::prosfora'),
            bg: 'tw-bg-blue-600',
            color: 'tw-text-white'
          }
        case OfferState.ACCEPTED:
          return {
            label: t('accepted::prosfora'),
            bg: 'tw-bg-green-500',
            color: 'tw-text-white'
          }
        case OfferState.EXPIRED:
          return {
            label: t('expired::prosfora'),
            bg: fullRow.value ? 'tw-bg-grey-200' : 'tw-bg-grey-300',
            color: fullRow.value ? 'tw-text-grey-500' : 'tw-text-grey-600'
          }
        case OfferState.REJECTED:
          return {
            label: t('rejected::prosfora'),
            bg: 'tw-bg-red-300',
            color: 'tw-text-white'
          }
        case OfferState.WITHDRAWN:
          return {
            label: t('cancelled::prosfora'),
            bg: 'tw-bg-grey-300',
            color: 'tw-text-grey-600'
          }
        default:
          return null
      }
    })

    const onRootClick = () => {
      if (!showDiv.value) {
        emit('click')
      }
    }

    const onStateConfirm = (state: OfferState) => {
      emit('set-offer-state', {
        offerId: offer.value.id,
        state
      })
    }

    const showDiv = computed(() => {
      return fullRow.value || offerCancelled.value || received.value
    })

    const previewThreadLink = computed(() => {
      const accountMessagesUrl = router.resolve({
        name: '__account_messages'
      }).href
      if (fullRow.value) {
        let link = ''

        if (isDealer || isAdmin) {
          link = accountMessagesUrl
        } else {
          link = accountMessagesUrl
        }

        return `${link}?thread=${offer.value.thread.id}`
      }
      return null
    })

    const isIframe = computed(() => {
      return Boolean(route.value.meta?.isIframe)
    })

    const selfTarget = computed(() => {
      return isIframe.value ? '_parent' : '_self'
    })

    const showCancelButton = computed(() => {
      return (
        !(offerRejected.value || offerAccepted.value || offerCancelled.value) &&
        !received.value &&
        !inBlock.value &&
        offersEnabled.value
      )
    })

    const showCounterButton = computed(() => {
      return offerRejected.value && !inBlock.value && offersEnabled.value
    })
    const showRightButton = computed(() => {
      return (
        showCancelButton.value ||
        showMessageButton.value ||
        showCounterButton.value
      )
    })

    const cancelActionType = computed(() => {
      if (received.value || (!initialOfferMine.value && received.value)) {
        return OfferActions.REJECT
      }

      return OfferActions.CANCEL
    })

    return {
      ciChatBubble,
      ciEnvelope,
      ciOffers,
      stateInfo,
      received,
      offerUser,
      onStateConfirm,
      onRootClick,
      formattedStartingPrice,
      offerPending,
      offerRejected,
      offerExpired,
      offerAccepted,
      offerCancelled,
      offerRejectedOrCancelled,
      showMessageButton,
      showCancelButton,
      showCounterButton,
      showRightButton,
      previewThreadLink,
      isDealer,
      selfTarget,
      OfferActions,
      latestBid,
      showDiv,
      isCounteroffer,
      startingPrice,
      initialOfferMine,
      thumbUrls,
      noPhoto,
      canSeeThread,
      offersEnabled,
      cancelActionType
    }
  }
})
